import React, { useState, useEffect } from 'react'
import { Input, Button } from 'antd'
import { Navigate } from "react-router-dom";
import { authUser } from './service/auth.service'

const MemberLogin = () => {
  const [mobileNo, setMobileNo] = useState(false)
  const [password, setPassword] = useState(false)

  const onLogin = async () => {
    try {
      const payload = {
        mobile_no: mobileNo,
        password
      }

      const response = await authUser(payload)
      localStorage.setItem("auth", true)
      localStorage.setItem("token", response.data.data.token)
      localStorage.setItem("uid", response.data.data.loginStamp)

      window.location = window.location.pathname.split("/")[0] + "/"

      setTimeout(() => {
        window.location.reload()
      }, 550);

    } catch (error) {
      console.log("error,", error);
      localStorage.setItem("auth", false)
      localStorage.setItem("token", false)
      localStorage.setItem("uid", false)
    }
  }

  const onLogout = () => {
    localStorage.setItem("auth", false)
    localStorage.setItem("token", false)
    localStorage.setItem("uid", false)
    // window.location("/")
    window.location.reload()
  }

  return (
    <div className="cs-font-30 cs-lm-10 cs-clr-fff" style={{ marginTop: 62 }}>
      {!JSON.parse(localStorage.getItem("auth")) ? <div>

        <div style={{ color: "#000" }}>
          Login
        </div>
        <Input onChange={(e) => setMobileNo(e.target.value)} placeholder='Mobile no' />
        <Input onChange={(e) => setPassword(e.target.value)} type='password' placeholder='Password' />

        <Button onClick={onLogin}>
          Login
        </Button>
      </div> :

        <Button onClick={onLogout}>
          Logout
        </Button>}
    </div>
  )
}

export default MemberLogin